import React from 'react';
import ReactECharts from 'echarts-for-react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import StatCard from '../components/dashboard/StatCard';

const { FiTrendingUp, FiUsers, FiClock, FiActivity } = FiIcons;

export default function Analytics() {
  const chartOption = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis' },
    legend: { textStyle: { color: '#94a3b8' }, top: 0 },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { 
      type: 'category', 
      data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
      axisLine: { lineStyle: { color: '#334155' } },
      axisLabel: { color: '#94a3b8' }
    },
    yAxis: { 
      type: 'value',
      splitLine: { lineStyle: { color: '#1e293b' } },
      axisLabel: { color: '#94a3b8' }
    },
    series: [
      {
        name: 'Course Completion',
        type: 'line',
        smooth: true,
        data: [120, 132, 101, 134, 90, 230],
        lineStyle: { color: '#6366f1' },
      },
      {
        name: 'Community Engagement',
        type: 'line',
        smooth: true,
        data: [220, 182, 191, 234, 290, 330],
        lineStyle: { color: '#a855f7' },
      }
    ]
  };

  return (
    <div className="space-y-8">
      <header>
        <h1 className="text-3xl font-bold text-white">Success Insights</h1>
        <p className="text-slate-400 mt-1">Deep dive into your platform's performance and student success.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard title="Avg. Completion" value="68%" change="+5%" icon={FiTrendingUp} trend="up" />
        <StatCard title="Retention" value="92%" change="+2%" icon={FiUsers} trend="up" />
        <StatCard title="Session Time" value="14m" change="-1%" icon={FiClock} trend="down" />
        <StatCard title="Active Pulse" value="High" change="Stable" icon={FiActivity} trend="up" />
      </div>

      <div className="bg-slate-900 border border-slate-800 rounded-3xl p-8">
        <h3 className="text-xl font-bold text-white mb-8">Platform Engagement Trends</h3>
        <ReactECharts option={chartOption} style={{ height: '400px' }} />
      </div>
    </div>
  );
}